var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    fill: "none",
    width: 54,
    height: 54
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    fill: "none",
    width: 54,
    height: 54
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    fill: "none",
    width: 54,
    height: 54
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    fill: "#8c8c8c",
    d: "M45.563,37.124H1.687A1.689,1.689,0,0,1,0,35.438V1.687A1.689,1.689,0,0,1,1.687,0H45.563a1.689,1.689,0,0,1,1.687,1.687V35.438A1.689,1.689,0,0,1,45.563,37.124ZM14.952,19.245a.418.418,0,0,0-.324.15L5.648,30.049a.437.437,0,0,0-.1.273.422.422,0,0,0,.421.421H41.276a.425.425,0,0,0,.273-.1.432.432,0,0,0,.063-.591L29.5,15.73a.341.341,0,0,0-.036-.037l-.017-.016a.426.426,0,0,0-.272-.1.418.418,0,0,0-.324.15l-8.337,9.888L15.277,19.4a.341.341,0,0,0-.036-.037l-.017-.016A.426.426,0,0,0,14.952,19.245Zm-.5-11.652a3.375,3.375,0,1,0,3.376,3.376A3.378,3.378,0,0,0,14.448,7.594Z",
    transform: "translate(3.375 8.438)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageDefault);
export default __webpack_public_path__ + "static/media/image-default.75ef49c6.svg";
export { ForwardRef as ReactComponent };